import config from 'config';
import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';


import createAction from './';
import * as services from '../services/organizationDetails';

export const GET_LOGIN_ORGANIZATION_DETAILS = createAsyncAction(createAction('GET_LOGIN_ORGANIZATION_DETAILS'));

export const getLoginOrganizationDetails = () => (dispatch, getState) => {
  dispatch({ type: GET_LOGIN_ORGANIZATION_DETAILS.pending });

  const state = getState();
  const orgId = state.auth.organizations.selectedOrganizationToken || Number(config.org_id);
  const locale = getCurrentLanguage();

  const apiCallParams = {
    query: services.GET_LOGIN_ORGANIZATION_DETAILS,
    variables: {
      orgId,
      locale: locale.toUpperCase(),
    },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organizationDetails } }) => {
      const {
        loginConfig,
        config: {
          reCaptchaSiteKey,
          patientLoginMethod,
          hasTermsAndConditions,
        },
      } = organizationDetails;

      return dispatch({
        type: GET_LOGIN_ORGANIZATION_DETAILS.success,
        payload: {
          orgId,
          locale,
          hasTermsAndConditions,
          patientLoginMethod,
          reCaptchaSiteKey,
          organizationStoreLink: organizationDetails.link,
          loginConfig,
        },
      });
    })
    .catch((err) => {
      dispatch(errorAction(GET_LOGIN_ORGANIZATION_DETAILS.failure, err));
    });
};
